import React, { FC } from 'react';
import { IconRegistry as LCIconRegistry } from '@lambdacurry/component-library';

import * as icons from '../../assets/icons';

export const IconRegistry: FC = props => <LCIconRegistry icons={icons} {...props} />;
